module.exports = __webpack_public_path__ + "img/reset-active.bec08175.svg";